/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 20:34:44 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-27 10:58:15
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.pricing.h1') }}</h1>
      <h2>{{ st('helpDocs.pricing.h2Pub') }}</h2>
      <p>{{ st('helpDocs.pricing.pPub1') }}</p>
      <p>{{ st('helpDocs.pricing.pPub2') }}</p>
      <h2>{{ st('helpDocs.pricing.h2Fee') }}</h2>
      <p>{{ st('helpDocs.pricing.pFee') }}</p>
      <h2>{{ st('helpDocs.pricing.h2Monthly') }}</h2>
      <p>{{ st('helpDocs.pricing.pMonthly') }}</p>
      <p>{{ st('helpDocs.pricing.pClosing') }}</p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>
